module.exports = __webpack_public_path__ + "img/invite_shareBtn.7d039e43.png";